import { GrowthBookProvider } from "@growthbook/growthbook-react";
import { type PropsWithChildren } from "react";

import { growthbook } from "@/lib/growthbook";

export function FeatureFlagsProvider({ children }: PropsWithChildren) {
  return (
    <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>
  );
}
